import ReactGA from 'react-ga';

export default ReactGA;